// Mirrors the `updateState` values produced by the user reducer
// (see `src/reducers/user.js` initialState comment).
export const UPDATE_SUCCESS = 2;
